import React from "react";

import { ErrorBoundary } from "./ui/ErrorBoundary";

export default function withErrorBoundary<Props extends object>(
  WrappedComponent: React.ComponentType<Props>
) {
  return function WithErrorBoundary(props: Props) {
    return (
      <ErrorBoundary>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };
}
